import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/tarifas")({
  beforeLoad: () => {
    throw redirect({ to: "/en/pricing", statusCode: 301 });
  },
});
